// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3_B7c","header":"MergedInvoice_header__1EIA5"};